import React from 'react';

// Navbar is now superseded by the unified DashboardLayout sidebar.
// Returning null safely avoids duplicate headers while preserving all component imports.
export default function Navbar() {
  return null;
}
